<script>
	const Vue = require('vue');
	const cache = require('cache');
	const Q = require('q');
	const metadata = require('core/metadata');
	const utilities = require('utilities');
	const pubsub = require('events/pubsub');
	const model = require('model/model');
	const page = require('page');
	const _ = require('underscore');

	const productService = require('services/productService');
	const accountService = require('services/accountService');
	const classService = require('services/classService');

	const alertUtilities = require('utilities/alertUtilities');
	const {
		fireEvent,
		events: { ADD_COTEACHER, REMOVE_COTEACHER, COTEACHER_LEAVE_CLASS }
	} = require('utilities/analyticsUtilities');

	const classUtilities = require('utilities/classUtilities');
	const sortStudentsByName = classUtilities.sortStudentsByName;

	const { authenticateWithGoogleClassroom, isInvalidatingGoogleError /* isKnownGoogleClass */ } = require('utilities/googleClassroomUtilities');

	const studentGroupUtilities = require('utilities/studentGroupUtilities');
	const createStudentGroup = studentGroupUtilities.createStudentGroup;
	const renameStudentGroup = studentGroupUtilities.renameStudentGroup;
	const addStudentsToGroup = studentGroupUtilities.addStudentsToGroup;
	const removeStudentsFromGroup = studentGroupUtilities.removeStudentsFromGroup;
	const deleteGroup = studentGroupUtilities.deleteGroup;

	const urlUtilities = require('utilities/urlUtilities');
	const userContext = require('core/userContext');

	module.exports = {
		props: ['classes', 'archiveDate'],
		modelData: {
			classAdmin: 'classAdmin',
			classCode: 'classCode',
			returnToProduct: 'returnToProduct',
			userContext: 'userContext',
			welcomeCoteacher: 'welcomeCoteacher',
			showGCImportDialog: 'showGCImportDialog',
			localGCAccessToken: 'localGCAccessToken',
			rosterView: 'rosterView',
			studentGroups: 'studentGroups',
			roster: 'allRosters',
			returnToAADAH: 'returnToAADAH',
			dismissGroupStudentRemovalMessage: 'dismissGroupStudentRemovalMessage',
			gcClassList: 'gcClassList'
		},
		components: {
			'validated-form': require('components/validated-form.vue').default,
			'validated-input': require('components/validated-input.vue').default,
			'info-icon': require('components/svg/info-icon.vue').default,
			'class-library-settings': require('components/routes/class-admin/class-library-settings.vue').default,
			'outbound-link': require('components/outbound-link.vue').default,
			'tab-container': require('components/tab-container.vue').default,
			'form-submitter': require('components/form-submitter.vue').default
		},
		data() {
			let showResultsTooltip = `You can choose when to share results with students by using the 'Options' menu next to the assignment in the 'Assignments & Progress' tab.
			<br />
			<a target="_blank"
				href="https://help.readworks.org/article/77-how-do-i-share-results-with-my-students"
				data-outbound-link="SHOW_RESULTS">
				See how.
			</a>`;

			return {
				renameClassForm: {
					classCode: '',
					name: ''
				},
				addCoteacherEmail: '',
				successCount: null,
				returnToProductData: null,
				coteachers: null,
				pendingCoteachers: null,
				loadingClass: true,
				loadingCoteachers: false,
				loadingPendingCoteacher: false,
				showResultsTooltip,
				tokenExpired: false,
				loadingGCRoster: false,
				selectedGroupStudents: [],
				groupLoading: false,
				groupName: null,
				editGroup: null,
				classSettingDialog: 'NoSelection',
				allowCoteacherInvites: true,
				returnToTraining: false,
				returnToScopeAndSequence: false,
				multipleGCImport: false,
				addedAsCoteacherData: null
			};
		},
		watch: {
			classCode: {
				handler(classCode) {
					this.renameClassForm.classCode = classCode || '';
					if (!classCode) {
						this.loadingClass = null;
						this.renameClassForm.name = '';
					} else if (this.loadingClass !== classCode) {
						this.loadingClass = classCode;
						classService
							.getClassRoster({
								classCode
							})
							.then(res => {
								if (res && res.name) {
									this.renameClassForm.name = res.name;
								}
								this.fetchRoster();
								this.fetchGroups();
								this.showInitialGCImportModal();
							})
							.finally(() => (this.loadingClass = null));
					}
				},
				immediate: true
			},
			roster: {
				handler(roster) {
					if (!roster || !roster.students || roster.students.length === 0) {
						return;
					}

					if (this.welcomeCoteacher === this.classCode) {
						model.remove('welcomeCoteacher');
						utilities.openModal('#modal-welcome-coteacher');
					} else if (this.classAdmin === 'add') {
						utilities.openModal('#modal-add-tr-students');
						this.classAdmin = 'roster';
					}
				},
				immediate: true,
				deep: true
			},
			ownThisClass(o) {
				if (o) {
					this.fetchCoteachers();
				}
			}
		},
		mounted() {
			let self = this;

			if (self.returnToProduct) {
				productService.get(self.returnToProduct).then(function (p) {
					self.returnToProductData = p || null;
				});
			} else {
				self.returnToProductData = null;
			}

			if (model.get('returnToAADAH')) {
				this.returnToTraining = true;
			} else if (model.get('scopeSequenceLink')) {
				this.returnToScopeAndSequence = true;
			}
			model.remove('returnToAADAH');
			model.remove('scopeSequenceLink');

			this.showInitialGCImportModal();

			pubsub.subscribe('submit-succeeded', function (evData) {
				switch (evData.formName) {
					case 'renameClassForm':
						pubsub.publish('message-success', 'Renamed class');
						break;
				}
				return true;
			});

			self.$subscribe('modal-opened', function (modalName) {
				if (modalName !== 'modal-rename-class') {
					return;
				}

				classService
					.getClassRoster({
						classCode: self.classCode
					})
					.then(function (res) {
						self.renameClassForm.name = res.body.name;
					});
			});

			pubsub.subscribe('student-added', () => {
				this.fetchRoster(true);
			});

			this.fetchRoster(true);
			this.fetchGroups();
		},
		computed: {
			roster() {
				let allRosters = this.allRosters;
				let classCode = this.classCode;
				let currentRoster = null;

				if (allRosters && allRosters[classCode]) {
					currentRoster = allRosters[classCode];
				}

				return currentRoster;
			},
			groups() {
				let roster = this.roster;
				let students = roster && roster.students ? roster.students : [];
				let groups = this.studentGroups || [];
				let studentsById = students.reduce((acc, s) => {
					acc[s.uid] = s;
					return acc;
				}, {});

				return groups.map(g => {
					let suids = Object.keys(g.suids || {});
					let count = 0;
					suids.forEach(suid => {
						if (studentsById[suid]) {
							count++;
						}
					});
					return _.assign({}, g, {
						count
					});
				});
			},
			rosterStudents() {
				let roster = this.roster;
				let students = roster && roster.students ? roster.students : [];
				let groups = this.studentGroups;

				if (students.length && groups && groups.length) {
					let groupDataByStudent = {};
					groups.forEach(g => {
						let studentsInGroup = Object.keys(g.suids || {});

						if (studentsInGroup.length) {
							studentsInGroup.forEach(s => {
								if (groupDataByStudent[s] && groupDataByStudent[s].length) {
									groupDataByStudent[s].push(g);
								} else {
									groupDataByStudent[s] = [g];
								}
							});
						}
					});
					students = students.map(s => {
						let groupData = groupDataByStudent[s.uid];
						let student = s;
						if (groupData && groupData.length) {
							let groupNames = groupData.map(g => g.n);
							student = _.assign(
								{
									groups: groupData,
									groupNames: groupNames.join(', ')
								},
								student
							);
						}
						return student;
					});
				}

				students.sort(sortStudentsByName);

				return students;
			},
			clazz() {
				let classes = this.classes || [];
				let classCode = this.classCode || null;
				let clazz = null;

				// TODO: Turn on babel to polyfill Array.find
				for (let i = 0; i <= classes.length; i++) {
					if (classes[i] && classes[i].classCode === classCode) {
						clazz = classes[i];
						break;
					}
				}

				return clazz;
			},
			assignmentSettings() {
				let clazz = this.clazz;
				let assignmentSettings = {};

				if (clazz && clazz.settings) {
					assignmentSettings = clazz.settings;
				}

				return assignmentSettings;
			},
			ownThisClass() {
				return this.clazz && this.userContext && this.clazz.uid === this.userContext.uid;
			},
			showRemoveCoteacher() {
				return this.ownThisClass && this.coteachers && this.coteachers.length === 1;
			},
			loading() {
				return this.loadingClass || this.loadingCoteachers || this.loadingGCRoster || this.groupLoading || this.loadingPendingCoteacher;
			},
			rosterGrades() {
				let clazz = this.clazz;
				let grades = [];
				if (clazz && clazz.grade) {
					let grade = metadata.allNodesById['_' + clazz.grade];

					if (grade && grade.id) {
						grades = [grade.id];
					}
				}
				return grades;
			},
			needsGoogleAuth() {
				const roster = this.roster;
				/* No GCA check needed - inaccessible in GCA */

				return roster && roster.gcid && (!this.localGCAccessToken || this.tokenExpired) /*  || !this.gcClassList || !isKnownGoogleClass(roster.gcid) */;
			},
			groupStudents() {
				let selectedGroupStudents = this.selectedGroupStudents;
				let rosterStudents = this.rosterStudents;
				return rosterStudents.map(s => {
					return _.assign({}, s, {
						selected: selectedGroupStudents.indexOf(s.uid) !== -1
					});
				});
			},
			allCoteachers() {
				let teachers = [];
				let coteachers = this.coteachers;
				let pendingCoteachers = this.pendingCoteachers;
				let pendingMap = null;

				if (pendingCoteachers && pendingCoteachers.length) {
					pendingMap = pendingCoteachers.reduce((acc, pct) => {
						acc[pct.e] = pct;
						return acc;
					}, {});
				}
				if (coteachers && coteachers.length) {
					teachers = coteachers.map(ct => {
						if (pendingMap && pendingMap[ct.e]) {
							delete pendingMap[ct.e];
						}
						return ct;
					});
				}
				if (pendingMap && Object.keys(pendingMap).length) {
					teachers = Object.keys(pendingMap)
						.map(e => pendingMap[e])
						.sort((a, b) => (a.c > b.c ? 1 : -1))
						.concat(teachers);
				}
				return teachers;
			},
			hasOrganization() {
				return this.userContext?.organization;
			}
		},
		methods: {
			toggleCopyPaste: function (e) {
				let dcp = !e.target.checked;
				return this.updateAssignmentSettings({
					dcp
				});
			},
			toggleGoogleClassroomPublish(e) {
				let gcp = e.target.checked;
				return this.updateAssignmentSettings({
					gcp
				});
			},
			toggleBoKEdit(e) {
				let bokEdit = e.target.checked;
				return this.updateAssignmentSettings({
					bokEdit
				});
			},
			toggleShowStudentResults(e) {
				let showResults = e.target.checked;
				return this.updateAssignmentSettings({
					showResults
				});
			},
			updateAssignmentSettings(settings) {
				let params = _.assign(
					{
						cc: this.classCode
					},
					settings
				);

				return classService
					.assignmentSettings(params)
					.then(classUtilities.loadClasses)
					.then(() => {
						alertUtilities.success('Settings Updated.');
					});
			},
			lockClass: function () {
				let classes = this.classes || [];
				let classCode = this.classCode || null;

				var self = this;

				classService
					.lockClass({
						cc: this.classCode
					})
					.then(function () {
						classes = classes.map(c => {
							if (c.classCode === classCode) {
								c.locked = true;
							}
							return c;
						});

						utilities.closeModals();

						if (self.roster.rosterType === 'student') {
							pubsub.publish('message-success', 'Class Locked');
						} else {
							pubsub.publish('message-success', 'Class Passwords Locked');
						}
					});
			},
			unlockClass: function () {
				let classes = this.classes || [];
				let classCode = this.classCode || null;

				var self = this;

				classService
					.unlockClass({
						cc: this.classCode
					})
					.then(function () {
						classes = classes.map(c => {
							if (c.classCode === classCode) {
								c.locked = false;
							}
							return c;
						});

						utilities.closeModals();

						if (self.roster.rosterType === 'student') {
							pubsub.publish('message-success', 'Class Unlocked');
						} else {
							pubsub.publish('message-success', 'Class Passwords Unlocked');
						}
					});
			},
			doClassSetting: function (classSetting, event) {
				let clazz = this.clazz;
				let callbackMap = {
					'#modal-delete-class': this.onClassDeleted.bind(this),
					'#modal-archive-class': this.onClassArchived.bind(this)
				};

				if (event && event.target) {
					event.target.blur();
				}

				this.addCoteacherEmail = '';

				$('#delete-class-select').prop('selectedIndex', 0);

				if (classSetting === 'unlock') {
					this.unlockClass();
				} else if (classSetting === '#modal-manage-coteacher') {
					Q.all([this.fetchCoteachers(), this.fetchPendingCoteachers()]).spread((coteachers, pendingCoteachers) => {
						utilities.openModal(classSetting);
					});
				} else if (classSetting !== 'NoSelection') {
					utilities.openModal(classSetting, {
						clazz,
						callback: callbackMap[classSetting]
					});
				}

				this.classSettingDialog = 'NoSelection';
			},
			onClassArchived: function (classCode) {
				page('/class-admin');
				model.remove('classCode');
				model.set('classAdmin', 'active');
			},
			onClassDeleted: function (classCode) {
				Vue.set(this, 'renameClassForm', {
					classCode: '',
					name: ''
				});

				page('/class-admin');
				model.remove('classCode');
				model.set('classAdmin', 'active');
			},
			updateClass: function (params) {
				return classService.updateClass(params).then(res => {
					this.$emit('class-renamed', params.classCode, params.name);
					this.roster.name = params.name;
					return {};
				});
			},
			addKids: function (data, cb) {
				var self = this;

				accountService
					.createTeacherRosteredStudents({
						cc: this.classCode,
						students: $('textarea', this.$root.$el).val().split('\n')
					})
					.then(function (result) {
						self.successCount = result.count;

						utilities.openModal('#modal-add-tr-students-success');

						$('textarea', self.$root.$el).val('');

						pubsub.publish('class-creation-complete');

						cb(null, result);
					})
					.fail(cb);
			},
			selectStudent: function (student, modal) {
				classService
					.getClassRoster({
						classCode: this.classCode
					})
					.then(
						function (res) {
							this.$emit('student-selected', student, this.classCode, res, modal);
						}.bind(this)
					);
			},
			fetchCoteachers() {
				this.loadingCoteachers = true;
				return classService
					.getCoteachers({
						cc: this.classCode
					})
					.then(ct => {
						this.loadingCoteachers = false;
						this.coteachers = ct;
						return ct;
					});
			},
			fetchPendingCoteachers() {
				this.loadingPendingCoteacher = true;
				return classService
					.getPendingCoteachers({
						cc: this.classCode
					})
					.then(pct => {
						this.loadingPendingCoteacher = false;
						this.pendingCoteachers = null;
						this.allowCoteacherInvites = true;
						if (pct && pct.invites) {
							this.pendingCoteachers = Object.keys(pct.invites).map(t => _.assign({ p: true }, pct.invites[t]));
							this.allowCoteacherInvites = pct.a;
						}
						return this.pendingCoteachers;
					});
			},
			addCoteacher() {
				let cc = this.classCode;
				let e = this.addCoteacherEmail;
				this.loadingCoteachers = true;
				fireEvent(ADD_COTEACHER, {
					e
				});
				return classService
					.addCoteacher({
						cc,
						e
					})
					.then(() => {
						alertUtilities.success('Co-Teacher Invitation Sent');
						this.addCoteacherEmail = '';
						return this.fetchPendingCoteachers();
					})
					.finally(() => {
						this.loadingCoteachers = false;
					});
			},
			removeCoteacher(uid) {
				let cc = this.classCode;

				this.loadingCoteachers = true;
				fireEvent(REMOVE_COTEACHER, {
					uid
				});
				classService
					.removeCoteacher({
						cc,
						uid
					})
					.then(this.fetchCoteachers)
					.then(() => {
						alertUtilities.success('Co-Teacher removed.');
					})
					.finally(() => {
						this.loadingCoteachers = false;
						this.closeModals();
					});
			},
			async coteacherLeaveClass() {
				const cc = this.classCode;
				const rosterName = this.roster?.name ?? '';

				fireEvent(COTEACHER_LEAVE_CLASS, { cc });
				const { token } = await classService.coteacherLeaveClass({ cc });

				alertUtilities.success(`You have left the class  "${rosterName}" (Code: ${cc}).`);
				userContext.setToken(token);
				pubsub.publish('update-classes');
				page('/class-admin');
				this.closeModals();
			},
			closeModals() {
				utilities.closeModals();
			},
			fetchRoster(forceReload) {
				let classCode = model.get('classCode');
				let clazz = this.clazz;

				if (forceReload) {
					cache.invalidate('roster', classCode);
				}

				// When fetching roster, ensure teacher only fetches from their class list
				if (classCode && (forceReload || !this.roster)) {
					// clazz ensures classCode is in classes list
					if (clazz) {
						classUtilities.fetchRoster(classCode);
					} else {
						classService.getClasses().then(classes => {
							// User has access to requested classCode
							if (classes.some(c => c.classCode === classCode)) {
								classUtilities.fetchRoster(classCode);
							} else {
								// User has tried to request a class they aren't entitled to
								utilities.closeModals();
								model.remove('welcomeCoteacher');
								page('/find-content');
							}
						});
					}
				}
			},
			showInitialGCImportModal() {
				if (this.showGCImportDialog) {
					utilities.openModal('#modal-gc-import-initial');
					if (this.showGCImportDialog.gcCount) {
						this.multipleGCImport = true;
					} else if (this.showGCImportDialog.ofn && this.showGCImportDialog.oln) {
						this.addedAsCoteacherData = {
							cc: this.showGCImportDialog.cc,
							n: this.showGCImportDialog.n,
							ofn: this.showGCImportDialog.ofn,
							oln: this.showGCImportDialog.oln
						};
					}
					model.remove('showGCImportDialog');
				}
			},
			authenticateWithGoogle() {
				authenticateWithGoogleClassroom();
				// Listen for updated token and try again
				let remove = model.change('localGCAccessToken', (token, initial) => {
					if (!initial) {
						this.tokenExpired = false;
						remove();
					}
				});
			},
			syncRoster() {
				let token = this.localGCAccessToken;
				let cc = this.classCode;
				let tokenExpired = this.tokenExpired;

				if (token && !tokenExpired) {
					this.loadingGCRoster = true;
					classService
						.synchronizeGoogleClassroomRoster({
							cc,
							token
						})
						.then(result => {
							utilities.closeModals();

							if (result.newClassName) {
								this.$emit('class-renamed', cc, result.newClassName);
							}

							this.fetchRoster(true);
						})
						.catch(error => {
							if (isInvalidatingGoogleError(error)) {
								this.tokenExpired = true;
							} else {
								throw error;
							}
						})
						.finally(() => (this.loadingGCRoster = false));
				}
			},
			fetchGroups() {
				studentGroupUtilities.fetchGroups(this.classCode);
			},
			onCreateGroupClick() {
				// createStudentGroup('Foo Group 1', this.classCode);
				utilities.openModal('#modal-create-edit-student-group');
				this.editGroup = null;
				this.groupName = '';
				this.selectedGroupStudents = [];
			},
			onCreateEditGroupSubmit() {
				if (this.editGroup) {
					const removedStudents = this.getRemovedStudents(this.editGroup.suids, this.selectedGroupStudents);

					if (!this.dismissGroupStudentRemovalMessage && Object.keys(removedStudents).length > 0) {
						return this.confirmGroupStudentRemoval();
					}

					return this.editGroupSubmit();
				} else {
					return this.createGroupSubmit();
				}
			},
			createGroupSubmit() {
				let name = this.groupName;
				let classCode = this.classCode;
				let suids = this.selectedGroupStudents.reduce((acc, suid) => {
					acc[suid] = true;
					return acc;
				}, {});

				this.groupLoading = true;
				createStudentGroup(name, classCode, suids)
					.then(g => {
						this.selectedGroupStudents = [];
						this.groupName = '';
						this.closeModals();
					})
					.finally(() => (this.groupLoading = false));
			},
			onGroupStudentClick(student) {
				let selectedGroupStudents = [...this.selectedGroupStudents];
				let suid = student.uid;
				let suidIdx = selectedGroupStudents.indexOf(suid);

				if (suidIdx !== -1) {
					selectedGroupStudents.splice(suidIdx, 1);
				} else {
					selectedGroupStudents.push(suid);
				}

				this.selectedGroupStudents = selectedGroupStudents;
			},
			onEditGroupClick(group) {
				this.groupName = group.n;
				this.selectedGroupStudents = Object.keys(group.suids);
				this.editGroup = group;
				utilities.openModal('#modal-create-edit-student-group');
			},
			confirmGroupStudentRemoval() {
				utilities.openModal('#modal-remove-student-from-group-confirmation');
			},
			editGroupSubmit() {
				let editGroup = this.editGroup;
				let editGroupId = editGroup.id;
				let classCode = this.classCode;
				let groupName = this.groupName;
				let selectedGroupStudents = this.selectedGroupStudents;
				let addedSuids = this.getAddedStudents(editGroup.suids, selectedGroupStudents);
				let removedSuids = this.getRemovedStudents(editGroup.suids, selectedGroupStudents);
				let token = this.localGCAccessToken || undefined;
				let prms = Q();

				this.groupLoading = true;

				if (groupName !== editGroup.n) {
					prms = prms.then(() => renameStudentGroup(editGroupId, classCode, groupName));
				}

				if (Object.keys(addedSuids).length) {
					prms = prms.then(() => addStudentsToGroup(editGroupId, classCode, addedSuids, token));
				}
				if (Object.keys(removedSuids).length) {
					prms = prms.then(() => removeStudentsFromGroup(editGroupId, classCode, removedSuids, token));
				}

				prms
					.then(() => {
						this.selectedGroupStudents = [];
						this.groupName = null;
						this.editGroup = null;

						this.closeModals();
					})
					.catch(error => {
						if (isInvalidatingGoogleError(error)) {
							this.tokenExpired = true;
						} else {
							// Error somewhere in the group edit process. Reset the form.
							this.fetchGroups().then(groups => {
								let group = null;
								groups.some(g => {
									if (g.id === this.editGroupId) {
										group = g;
										return true;
									}
									return false;
								});
								if (group && group.suids) {
									this.editGroup = group;
									this.groupName = group.n;
									this.selectedGroupStudents = Object.keys(group.suids);
								}
							});
							throw error;
						}
					})
					.finally(() => {
						this.groupLoading = false;
					});

				return prms;
			},
			editGroupSubmitAndDismiss() {
				this.dismissGroupStudentRemovalMessage = true;
				this.editGroupSubmit();
			},
			onDeleteStudentGroupClick() {
				utilities.openModal('#modal-delete-student-group-confirm');
			},
			onDeleteGroupCancel() {
				utilities.openModal('#modal-create-edit-student-group');
			},
			deleteStudentGroup() {
				let editGroup = this.editGroup;
				let editGroupId = editGroup.id;
				let classCode = this.classCode;

				this.groupLoading = true;

				return deleteGroup(editGroupId, classCode)
					.then(() => {
						this.selectedGroupStudents = [];
						this.groupName = null;
						this.editGroup = null;

						this.closeModals();
					})
					.catch(error => {
						if (isInvalidatingGoogleError(error)) {
							this.tokenExpired = true;
						} else {
							throw error;
						}
					})
					.finally(() => {
						this.groupLoading = false;
					});
			},
			getAddedStudents(oldSuidMap, currentList) {
				return currentList
					.filter(suid => !oldSuidMap[suid])
					.reduce((acc, suid) => {
						acc[suid] = true;
						return acc;
					}, {});
			},
			getRemovedStudents(oldSuidMap, currentList) {
				let oldSuidList = Object.keys(oldSuidMap);
				let currentMap = currentList.reduce((acc, suid) => {
					acc[suid] = true;
					return acc;
				}, {});

				return oldSuidList
					.filter(suid => !currentMap[suid])
					.reduce((acc, suid) => {
						acc[suid] = true;
						return acc;
					}, {});
			},
			launchWorkspaceVideo() {
				utilities.openModal('#video-modal', {
					title: 'Student Workspace Overview',
					videoId: 350973303
				});
			},
			toProductURL(product) {
				return urlUtilities.getProductURL(product);
			},
			assetUrl(url) {
				return urlUtilities.assetUrl(url);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	.roster {
		.main-content {
			padding: 0;
			padding-bottom: 1.5rem;
		}

		.roster-header.main-header {
			padding-bottom: 0;

			.main-header-title,
			.main-header-back {
				clear: none;
				float: none;
			}

			.main-header-back {
				white-space: nowrap;
			}

			.roster-grade {
				display: block;
				text-transform: uppercase;
			}

			.google-classroom-button:not(.mismatch) {
				margin-top: 0.25rem;
			}
		}

		.roster-header-content {
			display: flex;
		}

		.roster-title {
			flex: 1 0 calc(100% - 15rem);
		}

		.main-header-action-wrapper {
			flex: 1 1 15rem;
		}

		.main-header-actions {
			display: flex;
			justify-content: flex-end;
			flex-wrap: wrap;
			padding: 0;

			li {
				margin-bottom: 0.25rem;
			}
		}

		.class-info {
			.class-roster,
			.student-groups {
				padding-top: 1.5rem;
			}

			.class-roster,
			.student-groups {
				margin-bottom: 3em;
			}

			.class-library-settings-container {
				margin-top: 1.5rem;
			}

			.caption {
				display: flex;
				justify-content: space-between;
				margin-bottom: 1rem;

				.caption-text {
					margin-right: 1rem;
				}

				button.button {
					min-width: 12rem;
					height: 3rem;
				}
			}

			.well {
				h3 {
					color: $c-slate-dark;
				}

				.link {
					cursor: pointer;
					color: $c-blue;

					&:hover {
						color: $c-slate-dark;
					}
				}
			}
		}
	}

	#modal-assignment-settings {
		label svg.info-icon {
			fill: $c-slate-dark;
		}
	}

	#modal-edit-student {
		section.modal-content {
			overflow: visible;
		}
	}

	#modal-create-edit-student-group {
		.group-students-header {
			display: flex;
			justify-content: space-between;
			margin: 0.5rem 0;
			color: $c-slate-dark;
		}

		.group-students {
			max-height: 17rem;
			overflow-y: auto;
			border: 1px solid $c-grey;
			margin-bottom: 2rem;
			border-radius: 4px;
			padding: 0.5rem;
			box-shadow: 0px 3px 3px $c-grey;

			.student-checkbox .group-name {
				float: right;
			}
		}

		.submit-wrapper {
			display: flex;
			justify-content: space-between;
			align-items: center;

			button.button[type='submit'] {
				margin: 0 0;
			}

			> * {
				height: auto;
			}
		}
	}

	#modal-manage-coteacher {
		.coteacher-list-header {
			display: flex;
			justify-content: space-between;
			margin: 0.5rem 0;
			color: $c-slate-dark;
		}

		.coteacher-list {
			max-height: 12rem;
			overflow-y: auto;
			border: 1px solid $c-grey;
			margin-bottom: 2rem;
			border-radius: 4px;
			padding: 0.5rem;
			box-shadow: 0px 3px 3px $c-grey;

			.coteacher-info {
				display: flex;
				align-items: center;
				padding-bottom: 0.25rem;
				margin-bottom: 0.25rem;
				border-bottom: 1px solid $c-grey;

				.coteacher-name {
					flex: 1;
					padding-right: 0.5rem;
					text-overflow: ellipsis;
					overflow: hidden;
					white-space: nowrap;
				}
			}
		}

		.coteacher-add-input {
			display: flex;
			align-items: baseline;

			.input-wrapper {
				flex: 1;
				padding-right: 1rem;

				> input[type='email'] {
					margin-top: 1rem;
				}
			}

			button {
				max-height: 3rem;
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.roster {
			.class-info {
				display: flex;

				.class-roster,
				.student-groups {
					flex: 1;
					margin-right: 2rem;
				}

				.class-actions {
					max-width: 22rem;
				}
			}

			.roster-title {
				flex-basis: calc(100% - 28rem);
			}

			.main-header-action-wrapper {
				flex-basis: 28rem;
			}

			.main-header-actions {
				margin-top: 1rem;
			}
		}
	}
</style>
<template>
	<div class="roster">
		<header class="roster-header main-header">
			<div class="wrapper">
				<div class="roster-header-content">
					<div class="roster-title">
						<template v-if="returnToTraining">
							<a
								href="/article-a-day-at-home-digital"
								class="main-header-back">
								&larr; Back to Training Page
							</a>
						</template>
						<template v-if="!returnToTraining && returnToProductData && !returnToScopeAndSequence">
							<a
								:href="toProductURL(returnToProductData)"
								class="main-header-back">
								&larr; Back to &ldquo;{{ returnToProductData.title }}&rdquo;
							</a>
						</template>
						<template v-if="!returnToTraining && !returnToProduct && !returnToScopeAndSequence">
							<a
								v-if="classes && classes.length > 1"
								href="/class-admin#!classAdmin:active/"
								class="main-header-back">
								&larr; Back to Class Admin
							</a>
						</template>
						<template v-if="returnToScopeAndSequence">
							<a
								href="/find-content#!contentTab:scope-and-sequence"
								class="main-header-back">
								&larr; Back to Scope & Sequence
							</a>
						</template>
						<h1 class="main-header-title">
							{{ roster ? roster.name : '' }}
						</h1>
						<span
							v-if="rosterGrades.length"
							class="roster-grade font-small text-muted"
							>{{ rosterGrades | getGradeRangeWithOrdinal }} Grade</span
						>
					</div>
					<div class="main-header-action-wrapper">
						<ul class="main-header-actions">
							<li v-if="clazz && clazz.gcid">
								<button
									class="button -link google-classroom-button"
									:class="{
										mismatch: needsGoogleAuth
									}"
									@click="needsGoogleAuth && authenticateWithGoogle()"
									v-tooltip="needsGoogleAuth ? 'Please authenticate the Google account used to manage this Classroom' : 'Google Classroom'">
									<i
										v-if="needsGoogleAuth"
										class="mismatch-icon fa-solid fa-circle-exclamation"
										aria-hidden="true"></i>
									<img
										class="google-icon"
										:src="assetUrl('/assets/dist/images/google-classroom/gc_square_color_32.png')"
										alt="" />
								</button>
							</li>
							<li>
								<button
									data-modal="#modal-create-class"
									v-if="!hasOrganization"
									class="button -outline create-class-button">
									Create a Class
								</button>
							</li>
							<li>
								<form
									role="form"
									class="form"
									novalidate
									v-on:change="doClassSetting(classSettingDialog, $event)">
									<div class="input-select">
										<select
											id="delete-class-select"
											v-if="clazz && userContext"
											:disabled="loading || needsGoogleAuth"
											v-model="classSettingDialog">
											<option value="NoSelection">Options</option>
											<option
												value="#modal-rename-class"
												v-if="!clazz.gcid && !hasOrganization">
												Rename Class
											</option>
											<option value="#modal-assignment-settings">Assignment Settings</option>
											<option
												value="#modal-gc-roster-sync"
												v-if="clazz.gcid">
												Sync Roster
											</option>
											<option
												v-if="!clazz.locked && roster && roster.rosterType === 'student' && !hasOrganization"
												value="#modal-lock-class">
												Lock Class
											</option>
											<option
												v-if="!clazz.locked && ownThisClass && roster && roster.rosterType === 'teacher' && !hasOrganization"
												value="#modal-lock-class">
												Lock Passwords
											</option>
											<option
												v-if="clazz.locked && roster && roster.rosterType === 'student' && !hasOrganization"
												value="unlock">
												Unlock Class
											</option>
											<option
												v-if="clazz.locked && ownThisClass && roster && roster.rosterType === 'teacher' && !hasOrganization"
												value="unlock">
												Unlock Passwords
											</option>
											<option
												v-if="ownThisClass && !hasOrganization"
												value="#modal-manage-coteacher">
												Manage Co-Teachers
											</option>
											<option
												v-if="!hasOrganization && ownThisClass"
												value="#modal-archive-class">
												Archive Class
											</option>
											<option
												v-if="!hasOrganization && ownThisClass"
												value="#modal-delete-class">
												Delete Class
											</option>
											<option
												v-if="!ownThisClass"
												value="#modal-leave-class">
												Leave Class
											</option>
										</select>
									</div>
								</form>
							</li>
						</ul>
					</div>
				</div>
				<tab-container
					class="roster-tabs"
					model-key="rosterView">
					<button data-tab="students">Roster</button>
					<button data-tab="groups">Groups</button>
					<button data-tab="library">Student Library</button>
				</tab-container>
			</div>
		</header>
		<div
			class="main-content wrapper"
			ref="rosterViewPanel"
			:data-panel="rosterView">
			<div class="class-info">
				<div
					v-if="rosterView === 'students'"
					class="class-roster">
					<div class="roster-caption caption">
						<span class="caption-text">
							<template v-if="!loading && rosterStudents.length > 0">
								{{ rosterStudents.length }} {{ rosterStudents.length > 1 ? 'Students' : 'Student' }}.
								<template v-if="!hasOrganization">Click on the username to edit the student account or remove it from the class.</template>
							</template>
							<template v-if="!loading && rosterStudents.length === 0"> There are no students in this class yet. </template>
							<template v-if="loading">
								Loading your roster...
								<img
									:src="assetUrl('/assets/dist/images/loader.gif')"
									alt="Loading"
									role="presentation" />
							</template>
						</span>
						<button
							v-if="renameClassForm.classCode && roster && roster.rosterType === 'teacher'"
							data-modal="#modal-add-tr-students"
							class="button">
							Add More Students
						</button>
						<button
							v-if="renameClassForm.classCode && roster && roster.rosterType === 'student' && !(clazz && clazz.gcid)"
							data-modal="#modal-sr-help"
							class="button">
							Add More Students
						</button>
					</div>
					<table>
						<thead>
							<tr>
								<th>Student</th>
								<th v-if="!hasOrganization">Password</th>
								<th>Group(s)</th>
								<th>Last Login</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="student in rosterStudents"
								:key="student.uid">
								<th>
									<a
										v-bind:class="{
											'student-name': true,
											'error-text': student.accountDisabled
										}"
										v-on:click="selectStudent(student, '#modal-edit-student')">
										{{ student.firstName + (student.lastName ? ' ' + student.lastName : '') }}
									</a>
								</th>
								<td v-if="!hasOrganization">
									<a
										v-if="roster && roster.rosterType === 'teacher'"
										v-on:click="selectStudent(student, '#modal-change-student-password')"
										class="text-muted">
										Reset
									</a>
									<div
										class="text-muted"
										v-if="roster && roster.rosterType === 'student'">
										Administered via Google
									</div>
								</td>
								<td>
									<template v-if="!student.groups"> - </template>
									<template v-if="student.groups && student.groups.length === 1">
										{{ student.groups[0].n }}
									</template>
									<template v-if="student.groups && student.groups.length > 1">
										<button
											class="button -link"
											v-tooltip="student.groupNames">
											{{ student.groups.length }} groups
										</button>
									</template>
								</td>
								<td>{{ student.lastLogin | ago }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div
					v-if="rosterView === 'groups'"
					class="student-groups">
					<div class="group-caption caption">
						<span class="caption-text">
							<template v-if="!loading && groups.length > 0">
								{{ groups.length }} {{ groups.length > 1 ? 'Groups' : 'Group' }}.
								<template v-if="!hasOrganization">Click on the name to edit the group or remove it from the class.</template>
							</template>
							<template v-if="!loading && groups.length === 0"> There are no groups for this class yet. </template>
							<template v-if="loading">
								Loading your groups...
								<img
									:src="assetUrl('/assets/dist/images/loader.gif')"
									alt="Loading"
									role="presentation" />
							</template>
						</span>
						<button
							class="button"
							@click="onCreateGroupClick">
							Create a Group
						</button>
					</div>
					<table class="group-table">
						<thead>
							<tr>
								<th>Name</th>
								<th>No. of Students</th>
								<th>Last Edited</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="group in groups"
								:key="group.id">
								<th>
									<a @click="onEditGroupClick(group)">{{ group.n }}</a>
								</th>
								<td>
									<template v-if="group.count !== 1"> {{ group.count }} Students </template>
									<template v-if="group.count === 1"> {{ group.count }} Student </template>
								</td>
								<td>{{ group.u | date }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div
					v-if="rosterView === 'library'"
					class="class-library-settings-container">
					<class-library-settings
						:assignment-settings="assignmentSettings"
						:update-assignment-settings="updateAssignmentSettings"
						:clazz="clazz"></class-library-settings>
				</div>
				<aside
					v-else-if="roster && !hasOrganization"
					class="class-actions form">
					<div class="well">
						<template v-if="!roster.gcid">
							<h2>How to get students to their assignments</h2>
							<p>
								1. Have students go to
								<strong>www.readworks.org/student</strong>
							</p>
							<div v-if="roster.rosterType === 'student'">
								<p>2. Students should sign in with their Google account.</p>
								<p>
									3. Students enter class code <strong>{{ classCode }}</strong>
								</p>
							</div>
							<div v-if="roster.rosterType === 'teacher'">
								<p>
									2. Students enter class code <strong>{{ classCode }}</strong>
								</p>
								<p>3. Tell your students that their default password is <strong>1234</strong></p>
								<p><strong>Note:</strong> Students can change their passwords when they log in, and you can change student passwords on this page.</p>
							</div>
						</template>
						<template v-if="roster.gcid">
							<h2>Managing your Class</h2>
							<p>
								If your Google Classroom roster changes, you can use the Sync Roster option above. This will add students from Google Classroom who do not
								appear here and remove students listed here that are no longer in your Google Classroom.
							</p>
							<p>
								Students may also join the class automatically by clicking on an assignment link in the Google Classroom stream, provided the class is not
								locked. Likewise, you can manually remove students from your ReadWorks roster by clicking their name.
							</p>
						</template>
						<div>
							<h2>Student Experience</h2>
							<div>
								<span
									class="link"
									@click="launchWorkspaceVideo">
									Watch this video
								</span>
								to preview the student experience and
								<outbound-link
									href="https://about.readworks.org/digital-student.html"
									data-outbound-link="CLASS_ROSTER_STUDENT_RESOURCES">
									share these resources
								</outbound-link>
								with your students to get them started.
							</div>
						</div>
					</div>
				</aside>
			</div>
		</div>
		<!-- Start of modal dialog: GC Import Initial -->
		<modal
			id="modal-gc-import-initial"
			v-bind:loading="loading">
			<template slot="header-container">
				<h2 v-if="!addedAsCoteacherData">Class Imported <span v-if="multipleGCImport">(warning)</span></h2>
				<h2 v-if="addedAsCoteacherData">Added as Coteacher</h2>
			</template>
			<template slot="content">
				<div class="text-centered">
					<div class="margin-bottom-medium">
						<div
							v-if="multipleGCImport"
							class="margin-bottom-medium">
							You successfully imported the class from Google Classroom. Please note, other teacher(s) have imported this class as well. To all share and
							co-teach the same class in ReadWorks, make sure you are all using the same import of the class.
						</div>
						<div
							v-if="addedAsCoteacherData"
							class="margin-bottom-medium">
							Your colleague {{ addedAsCoteacherData.ofn + ' ' + addedAsCoteacherData.oln }} has already imported
							{{ addedAsCoteacherData.n + ' (' + addedAsCoteacherData.cc + ')' }} from Google Classroom. Because it looks like you are co-teachers in Google
							Classroom, we've gone ahead and added you as a co-teacher in ReadWorks.
						</div>
						<b>Note:</b> Please make all changes to ReadWorks assignments on the ReadWorks site. If you make those changes in Google Classroom, the
						assignments in ReadWorks will not be updated.
					</div>
					<button
						class="submit button -large"
						type="button"
						@click="closeModals">
						Ok
					</button>
				</div>
			</template>
		</modal>
		<!-- Start of modal dialog: Co-teacher Welcome -->
		<modal
			id="modal-welcome-coteacher"
			v-bind:loading="loading">
			<template slot="header-container">
				<h2>You're a Co-Teacher!</h2>
			</template>
			<template slot="content">
				<div class="text-centered">
					<div class="margin-bottom-medium">You've been added to the class "{{ roster ? roster.name : '' }}". <br />(Class Code: {{ classCode }})</div>
					<button
						class="submit button -large"
						type="button"
						@click="closeModals">
						Ok
					</button>
				</div>
			</template>
		</modal>
		<!-- End of modal dialog: Co-teacher Welcome -->
		<!-- Start of modal dialog: Manage Co-teacher -->
		<modal
			id="modal-manage-coteacher"
			v-bind:loading="loading">
			<template slot="header-container">
				<h2>Manage Co-Teacher</h2>
			</template>
			<template slot="content">
				<div class="coteacher-list-header">
					<span>Coteacher{{ allCoteachers && allCoteachers.length > 1 ? 's' : '' }}</span>
				</div>
				<div class="input-wrapper coteacher-list">
					<div
						class="coteacher-info"
						v-for="teacher in allCoteachers"
						:key="teacher.uid">
						<span class="coteacher-name">
							{{ teacher.p ? teacher.e : teacher.f + ' ' + teacher.l }}
						</span>
						<span class="coteacher-options">
							<button
								v-if="!teacher.p"
								class="button -small"
								@click="removeCoteacher(teacher.uid)">
								Remove
							</button>
							<span v-if="teacher.p">(pending)</span>
						</span>
					</div>
					<div
						class="text-muted"
						v-if="!allCoteachers || !allCoteachers.length">
						You currently have no co-teachers or pending invitations.
					</div>
				</div>
				<validated-form
					v-if="allowCoteacherInvites"
					:on-submit="addCoteacher">
					<div class="margin-bottom-medium">
						<p>
							Invite a co-teacher to join class {{ roster ? roster.name : '' }} by entering their email address below. Your co-teacher will need to confirm
							their invitation to be added.
						</p>
					</div>
					<div class="coteacher-add-input margin-bottom-medium">
						<div class="input-wrapper">
							<validated-input
								class="input"
								type="email"
								id="coteacher-email-input"
								name="coteacherEmail"
								:debounce-delay="50"
								required
								override-message="Please enter a valid email for your co-teacher"
								v-model.trim="addCoteacherEmail">
							</validated-input>
							<label
								for="coteacher-email-input"
								placeholder="Email"
								alt="Email"></label>
						</div>
						<button
							class="submit button -small"
							type="submit">
							Invite
						</button>
					</div>
				</validated-form>
				<div
					v-if="!allowCoteacherInvites"
					class="margin-bottom-medium margin-top-medium">
					<span v-if="pendingCoteachers && pendingCoteachers.length < 10">
						You have reached your invitation limit for the moment. To send more invitations, please come back in 10 minutes.
					</span>
					<span v-if="pendingCoteachers && pendingCoteachers.length >= 10">
						You have reached your limit for pending invitations. To send more, wait for some of the pending invitations to be accepted
					</span>
				</div>
				<div class="text-centered">
					<button
						class="button -large -outline"
						type="button"
						@click="closeModals">
						Done
					</button>
				</div>
			</template>
		</modal>
		<!-- End of modal dialog: Manage Co-teacher -->
		<!-- Start of modal dialog: Co-teacher confirmation -->
		<modal
			id="modal-remove-coteacher"
			v-bind:loading="loading">
			<template slot="header-container">
				<h2>Remove Co-Teacher</h2>
			</template>
			<template slot="content">
				<div class="text-centered">
					<div class="margin-bottom-medium">
						You are removing your co-teacher from "{{ roster ? roster.name : '' }}". <br />(Class Code: {{ classCode }})
					</div>
					<button
						class="button -large -outline"
						type="button"
						@click="closeModals">
						Cancel
					</button>
					<button
						class="submit button -large"
						type="button"
						@click="removeCoteacher">
						Remove
					</button>
				</div>
			</template>
		</modal>
		<!-- End of modal dialog: Co-teacher confirmation -->
		<modal
			id="modal-assignment-settings"
			:ok="true">
			<template slot="header-container">
				<h2>Assignment Settings</h2>
			</template>
			<template slot="content">
				<form>
					<label>
						<input
							type="checkbox"
							@change="toggleCopyPaste"
							:checked="assignmentSettings.disableCopyPaste === false" />
						Allow students to copy/paste from articles.
					</label>
					<label v-if="clazz && clazz.gcid">
						<input
							type="checkbox"
							@change="toggleGoogleClassroomPublish"
							:checked="assignmentSettings.publishToGoogleClassroom !== false" />
						By default publish all assignments to Google Classroom (This may be changed at assignment time)
					</label>
					<label>
						<input
							type="checkbox"
							@change="toggleBoKEdit"
							:checked="!!assignmentSettings.bokEdit" />
						Allow students to edit Book of Knowledge entries.
					</label>
					<div>
						<label class="inline">
							<input
								type="checkbox"
								@change="toggleShowStudentResults"
								:checked="assignmentSettings.showResults !== false" />
							Allow students to view results directly after submission.
						</label>
						<button
							class="button -link"
							v-tooltip="showResultsTooltip">
							<info-icon></info-icon>
						</button>
					</div>
				</form>
			</template>
		</modal>
		<!-- Start of modal dialog: rename class -->
		<modal
			id="modal-rename-class"
			v-bind:loading="loading">
			<template slot="header-container">
				<h2>Rename Class</h2>
			</template>
			<template slot="content">
				<form-submitter
					class="form"
					novalidate
					form-name="renameClassForm"
					:form-data.sync="renameClassForm"
					:submit-to="updateClass">
					<auto-form-row
						v-bind:data.sync="renameClassForm.name"
						type="className"
						placeholder="Class Name"
						row-class="label-hidden-visually"
						required
						unsafe>
					</auto-form-row>
					<auto-form-row
						row-class="-full-width"
						v-bind:all-valid="renameClassForm.allValid"
						type="submit">
						Save
					</auto-form-row>
				</form-submitter>
			</template>
		</modal>
		<!-- End of modal dialog: rename class -->
		<div
			id="modal-sr-help"
			class="modal"
			data-modal-window>
			<div class="modal-container">
				<div class="modal-window">
					<div class="modal-window-wrap">
						<button
							class="modal-close"
							data-modal-close>
							<span aria-hidden="true">&times;</span><span class="hidden-visually"> Close</span>
						</button>
						<section class="modal-content">
							<header class="modal-content-header">
								<h2>Add Students To Class</h2>
							</header>
							<div class="modal-content-main">
								<p v-if="clazz && clazz.gcid"><strong>If you have students in Google Classroom who are not listed on your ReadWorks Class roster:</strong></p>
								<ol>
									<li>Have students go to <strong>www.readworks.org/student</strong></li>
									<li>Students should sign in with their Google account.</li>
									<li>
										Students enter class code <strong>{{ renameClassForm.classCode }}</strong>
									</li>
								</ol>
								<div class="modal-content-main -centered">
									<a
										data-modal-close
										class="button">
										OK
									</a>
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
		<modal id="modal-coteacher-invite-warning">
			<template slot="header-container">
				<h2>Invitation Pending</h2>
			</template>
			<template slot="content">
				<div class="margin-bottom-medium">
					You have recently sent a Co-Teacher invitation. For security reasons, you will need to wait 10 minutes before sending another invitation for this
					class.
				</div>
				<div class="text-centered">
					<button
						class="button"
						@click="closeModals">
						Ok
					</button>
				</div>
			</template>
		</modal>
		<!-- Lock class modal -->
		<modal id="modal-lock-class">
			<template slot="header-container">
				<h2>Are You Sure?</h2>
			</template>
			<template slot="content">
				<div class="margin-bottom-medium">
					<p v-if="roster && roster.rosterType === 'student' && !roster.gcid">No students will be able to join this class unless you unlock it.</p>
					<p v-if="roster && roster.rosterType === 'student' && roster.gcid">
						New students will not be able to join your ReadWorks class from the Google Classroom stream. If you need to add a student, you will have to
						unlock the class or else use the Sync Roster option.
					</p>
					<p v-if="roster && roster.rosterType !== 'student'">Students will not be able to change their passwords.</p>
				</div>
				<div class="text-centered">
					<button
						class="button"
						@click="lockClass">
						Yes
					</button>
					<button
						class="button"
						@click="closeModals">
						No
					</button>
				</div>
			</template>
		</modal>
		<!-- GC Roster Sync modal -->
		<modal id="modal-gc-roster-sync">
			<template slot="header-container">
				<h2>Sync Roster</h2>
			</template>
			<template slot="content">
				<div class="margin-bottom-medium">
					Syncing your roster will create student accounts that are present in Google Classroom but missing here, and remove student accounts (and their
					work) that are present here but not in Google Classroom.
				</div>
				<div
					class="text-centered margin-bottom-small"
					v-if="needsGoogleAuth">
					<button
						class="button"
						@click="authenticateWithGoogle">
						Authenticate with Google
					</button>
				</div>
				<div class="text-centered">
					<button
						class="button -outline"
						:disabled="loadingGCRoster"
						@click="closeModals">
						Cancel
					</button>
					<button
						class="button"
						:class="{
							'-in-progress': loadingGCRoster
						}"
						:disabled="needsGoogleAuth || loadingGCRoster"
						@click="syncRoster">
						Continue
					</button>
				</div>
			</template>
		</modal>
		<!-- Create Student Group Modal -->
		<modal id="modal-create-edit-student-group">
			<template slot="header-container">
				<h2 v-if="!editGroup">Create Student Group</h2>
				<h2 v-if="editGroup">Edit Student Group</h2>
			</template>
			<div slot="content">
				<validated-form :on-submit="onCreateEditGroupSubmit">
					<div class="input-wrapper">
						<validated-input
							type="text"
							class="group-name"
							:class="{
								touched: groupName
							}"
							v-model.trim="groupName"
							name="groupName"
							required
							unsafe></validated-input>
						<label
							for=""
							placeholder="Group Name"
							alt="Group Name"></label>
					</div>
					<div class="group-students-header">
						<span>Student</span>
						<span>Assigned Group(s)</span>
					</div>
					<div class="input-wrapper group-students">
						<label
							class="student-checkbox"
							v-for="student in groupStudents"
							:key="student.uid">
							<input
								type="checkbox"
								@click="onGroupStudentClick(student)"
								:checked="student.selected" />
							{{ student.firstName + (student.lastName ? ' ' + student.lastName : '') }}
							<span class="group-name">
								<template v-if="!student.groups"> - </template>
								<template v-if="student.groups && student.groups.length === 1">
									{{ student.groups[0].n }}
								</template>
								<template v-if="student.groups && student.groups.length > 1">
									<span :title="student.groupNames"> {{ student.groups.length }} groups </span>
								</template>
							</span>
						</label>
					</div>
					<div
						v-if="!selectedGroupStudents || selectedGroupStudents.length === 0"
						class="input-wrapper text-centered margin-bottom-medium">
						You must select at least one student to {{ editGroup ? 'save' : 'create' }} this group.
					</div>
					<div
						v-if="editGroup && needsGoogleAuth"
						class="input-wrapper text-centered margin-bottom-medium">
						You must authenticate with Google to edit this group.
						<div>
							<button
								class="button"
								v-if="editGroup && needsGoogleAuth"
								type="button"
								@click="authenticateWithGoogle">
								Authenticate with Google
							</button>
						</div>
					</div>
					<div class="input-wrapper submit-wrapper">
						<button
							type="button"
							@click="closeModals"
							class="button -outline"
							:disabled="loading">
							Cancel
						</button>
						<button
							type="button"
							v-if="editGroup"
							class="button -outline"
							@click="onDeleteStudentGroupClick"
							:disabled="needsGoogleAuth || loading">
							Delete
						</button>
						<button
							type="submit"
							class="button submit"
							:class="{
								'-in-progress': loading
							}"
							:disabled="(editGroup && needsGoogleAuth) || !selectedGroupStudents || selectedGroupStudents.length === 0 || loading">
							Save
						</button>
					</div>
				</validated-form>
			</div>
		</modal>
		<modal id="modal-remove-student-from-group-confirmation">
			<template slot="header-container">
				<h2>Update Group</h2>
			</template>
			<div slot="content">
				<p>
					You are removing one or more students from a group. If there are active assignments for that group, any partial or submitted work by the removed
					student(s) will be lost.
				</p>
				<p>To avoid losing student work, be sure all assignments for that group have ended.</p>
				<div class="text-centered margin-bottom-xs">
					<button
						type="button"
						class="button -outline cancel-button"
						@click="closeModals"
						:disabled="loading">
						Cancel
					</button>
					<button
						type="button"
						class="button confirm-button"
						@click="editGroupSubmit"
						:disabled="loading">
						Confirm
					</button>
				</div>
				<div class="text-centered">
					<button
						class="button -link dismiss-message"
						@click="editGroupSubmitAndDismiss">
						<span class="text-muted font-small"> Update group and don't ask me again. </span>
					</button>
				</div>
			</div>
		</modal>
		<modal id="modal-delete-student-group-confirm">
			<template slot="header-container">
				<h2>Delete Confirmation</h2>
			</template>
			<template slot="content">
				<div class="margin-bottom-medium text-centered">Are you sure you want to delete this group?</div>
				<div class="text-centered">
					<button
						class="button -outline"
						@click="onDeleteGroupCancel">
						Do Not Delete
					</button>
					<button
						class="button -danger"
						:class="{
							'-in-progress': loading
						}"
						@click="deleteStudentGroup">
						Yes
					</button>
				</div>
			</template>
		</modal>
		<!-- Start of modal dialog: Co-teacher leave class -->
		<modal
			id="modal-leave-class"
			:loading="loading">
			<template slot="header-container">
				<h2>Leave Class Confirmation</h2>
			</template>
			<template slot="content">
				<div class="text-centered">
					<p class="text-bold">You are leaving the class "{{ roster ? roster.name : '' }}". <br />(Code: {{ classCode }})</p>
					<p>Once you leave, you will no longer be able to access this class unless you are added back as a Co-Teacher.</p>
					<button
						class="button -outline"
						type="button"
						@click="closeModals">
						Cancel
					</button>
					<button
						class="leave-class button"
						type="button"
						@click="coteacherLeaveClass">
						Leave
					</button>
				</div>
			</template>
		</modal>
		<!-- End of modal dialog: Co-teacher leave class -->
	</div>
</template>
